import { redirectToLogin } from './tokenValidation';

const API_URL = process.env.REACT_APP_API_URL;

const getToken = () => localStorage.getItem('loginToken');

export const apiFetch = async (
  endpoint: string,
  options: RequestInit = {}
): Promise<{ ok: boolean; status: number; data: any } | null> => {
  const url = endpoint.startsWith('http') ? endpoint : `${API_URL}${endpoint}`;

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${getToken()}`,
    ...(options.headers as Record<string, string> || {}),
  };

  const response = await fetch(url, { ...options, headers });
  const data = await response.json();

  if (data?.status === '1101') {
    redirectToLogin();
    return null;
  }

  return { ok: response.ok, status: response.status, data };
};
